import { render } from "./Graduate.vue?vue&type=template&id=2f4710eb&scoped=true"
import script from "./Graduate.vue?vue&type=script&lang=js"
export * from "./Graduate.vue?vue&type=script&lang=js"

import "./Graduate.vue?vue&type=style&index=0&id=2f4710eb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\tmeadows\\WebstormProjects\\tuitioncalculator\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4710eb"]])

export default __exports__